import React from "react";
import i18n from "../i18n";
import { Button } from "./ui";
export default class ErrorBoundary extends React.Component<
  React.PropsWithChildren,
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <section className="vl-public-content" role="alert">
        <h1>{i18n.t("ui:appErrorTitle")}</h1>
        <p>{i18n.t("ui:appErrorText")}</p>
        <Button onClick={() => window.location.reload()}>
          {i18n.t("ui:reload")}
        </Button>
      </section>
    );
  }
}
